import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";
import { PERMISSIONS, PERMISSIONS_MAP } from "../../auth/permissions";
import { User } from "../../models/authentication/user";
import { NidessoQueryParams } from "../router/query-params";

export const hasPermissions = (permissions: PERMISSIONS[], user?: User) => {
  return (
    !permissions.length ||
    (!!user &&
      permissions.every((permission) =>
        user.roles.some((role) => PERMISSIONS_MAP[role].includes(permission)),
      ))
  );
};

const PrivateRoute = ({
  children,
  permissions = [],
}: {
  children: JSX.Element;
  permissions?: PERMISSIONS[];
}) => {
  const { loggedIn, user } = useAuth();
  const location = useLocation();

  if (!loggedIn) {
    return (
      <Navigate
        to="/login"
        state={{ [NidessoQueryParams.Location]: location }}
      />
    );
  }

  if (!hasPermissions(permissions, user)) {
    throw Error("No permissions to view this page!");
  }

  return children;
};

export default PrivateRoute;
